<template>
  <div class="settings-country-dropdown">
    <v-dropdown ref="dropdown" width-auto position-right>
      <v-btn icon :loading="loading" @click="onClick">
        <i class="i-util-more"></i>
      </v-btn>
      <div class="settings-country-dropdown__content" v-if="loaded" slot="content">
        <v-card elevated>
          <v-card-title>
            <h2 class="card-title mb-3">{{ 'base.action' | translate }}</h2>
          </v-card-title>

          <v-card-actions>
            <div class="settings-country-dropdown__group">
              <v-btn small ghost @click="editClick">
                <v-icon position-left font-size="1" icon="pencil-alt" />
                <span>{{ this.$t('activities.edit') }}</span>
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </div>
    </v-dropdown>
  </div>
</template>

<script>

export default {
  name: 'SettingsCountryDropdown',
  props: {
    id: {
      type: Number,
      required: false,
      default: null
    }
  },

  data: () => ({
    form: {
      //   is_active: false
    },
    loading: false,
    loaded: false
  }),
  methods: {
    async onClick () {
      this.loaded = false
      this.loading = true
      this.loaded = true
      this.loading = false
    },
    editClick () {
      this.$emit('edit')
      this.closeDropdown()
    },
    closeDropdown () {
      this.$refs.dropdown.closeDropdown()
    }
  }
}
</script>

<style lang="scss" scoped>
.settings-country-dropdown {
  &__content {
    width: 18rem;
  }

  &__group:not(:last-child) {
    margin-bottom: 2rem;
  }
}
</style>